import { API_URL } from '../../../app-config/constants';
import type { DownloadableFile } from '../../../types/DownloadableFile';
import type { ExportFormat } from '../../../types/ExportFormat';
import type { Survey } from '../../../types/Survey';
import { get, post, put, remove } from '../request';

const ENTRY = `${API_URL}/surveys`;

const updateOnCreate = (args: [], x: Survey, xs: Survey[]) => [x, ...xs];

getSingle.operation = 'READ';
getSingle.byId = true;
export function getSingle(surveyId: string): Promise<Survey> {
    return get(`${ENTRY}/${surveyId}`);
}

getCompanyObserverSurvey.operation = 'NO_OPERATION';
export function getCompanyObserverSurvey(surveyId: string): Promise<Survey> {
    return get(`${API_URL}/company-observer/surveys/${surveyId}`);
}

getAll.operation = 'READ';
getAll.updateOnCreate = updateOnCreate;
export function getAll(): Promise<Survey[]> {
    return get(`${ENTRY}`);
}

createSurvey.operation = 'CREATE';
export function createSurvey(survey: Survey): Promise<Survey> {
    return post(`${ENTRY}`, { postData: survey });
}

getSurveySchedule.operation = 'NO_OPERATION';
export function getSurveySchedule(survey: Survey): Promise<string[]> {
    return post(`${API_URL}/survey-schedule`, { postData: survey });
}

// We are using 'COMMAND' to reload backend-based data (e.g., the currentInstance field).
updateSurvey.operation = 'COMMAND';
export function updateSurvey(survey: Survey): Promise<Survey> {
    return put(`${ENTRY}/${survey.id}`, { postData: survey });
}

archiveSurvey.operation = 'COMMAND';
export function archiveSurvey(surveyId: string): Promise<Survey> {
    return put(`${ENTRY}/${surveyId}/archive-status`, { postData: { archived: true } });
}

unarchiveSurvey.operation = 'COMMAND';
export function unarchiveSurvey(surveyId: string): Promise<Survey> {
    return put(`${ENTRY}/${surveyId}/archive-status`, { postData: { archived: false } });
}

updateStoppedStatus.operation = 'COMMAND';
export function updateStoppedStatus(surveyId: string, stopped: boolean): Promise<Survey> {
    return put(`${ENTRY}/${surveyId}/stopped-status`, { postData: { stopped } });
}

updateViewers.operation = 'COMMAND';
export function updateViewers(surveyId: string, viewerIds: Survey['viewerIds']): Promise<Survey> {
    return put(`${ENTRY}/${surveyId}/viewers`, { postData: viewerIds });
}

/**
 * Do not invalidate the getSingle() call because it'd erroneously re-request the survey on the dashboard page.
 */
deleteSurvey.operation = 'NO_OPERATION';
deleteSurvey.byId = true;
deleteSurvey.invalidates = [getAll.name];
export function deleteSurvey(surveyId: string): Promise<void> {
    return remove(`${ENTRY}/${surveyId}`);
}

exportSurvey.operation = 'NO_OPERATION';
export function exportSurvey(survey: Survey, format: ExportFormat): Promise<DownloadableFile> {
    return get(`${ENTRY}/${survey.id}/export?format=${format}`);
}
